// EINZIGER Ort, an dem Status-Farben referenziert werden.
// Visual System: triple-encoded (Form + Füllung + Icon + Code-Farbe) für Farbsehschwäche-Sicherheit.
// 0 → fehlt (transparent + dashed border)
// 1 → habe (grün + Check-Icon)
// ≥2 → doppelt (gold + ×N-Badge), N = count − 1

export type StickerStatus = 'fehlt' | 'habe' | 'doppelt';

export function statusOf(count: number): StickerStatus {
  if (count === 0) return 'fehlt';
  if (count === 1) return 'habe';
  return 'doppelt';
}

export function statusLabel(count: number): string {
  return statusOf(count);
}

/** Visual model für eine einzelne Sticker-Zelle. Liefert alles was die Cell rendern muss. */
export type CellVM = {
  bg: string;
  fg: string;
  border: string;
  showCheck: boolean;
  badge: string;
};

export function cellVM(count: number): CellVM {
  if (count === 1) {
    return {
      bg: 'var(--status-have)',
      fg: '#ffffff',
      border: '1.5px solid var(--status-have)',
      showCheck: true,
      badge: '',
    };
  }
  if (count >= 2) {
    return {
      bg: 'var(--status-double)',
      fg: 'var(--cell-double-fg)',
      border: '1.5px solid var(--status-double)',
      showCheck: false,
      badge: '×' + (count - 1),
    };
  }
  return {
    bg: 'transparent',
    fg: 'var(--cell-missing-fg)',
    border: '1.5px dashed var(--cell-missing-border)',
    showCheck: false,
    badge: '',
  };
}
